import React from 'react';

import FocusTrap from 'focus-trap-react';
import { Permission, User } from 'generated/graphql';

import Details, { VenueWithMenus } from 'components/SingleItem/Details';
import DetailsV1 from 'components/SingleItemV1/Details';
import { useParams } from 'react-router-dom';
import { QueuedProductImageUpdate } from 'types';

interface Props {
  currentVenue?: VenueWithMenus | undefined;
  currentUser: User | undefined | null;
  dietaryEnums: string[];
  queuedProductImageUpdates: QueuedProductImageUpdate[];
  updateQueuedProductImageUpdates: (updatedQueue: QueuedProductImageUpdate[]) => void;
}

const SingleItem: React.FC<Props> = ({
  currentVenue,
  currentUser,
  dietaryEnums,
  queuedProductImageUpdates,
  updateQueuedProductImageUpdates
}) => {
  const canEditItem = !!currentUser?.permissions?.includes(Permission.PublishMenu);
  const { menuId } = useParams();

  if (canEditItem)
    return (
      <FocusTrap
        active
        focusTrapOptions={{
          escapeDeactivates: false,
          clickOutsideDeactivates: true
        }}
      >
        <Details
          currentVenue={currentVenue}
          dietaryEnums={dietaryEnums}
          queuedProductImageUpdates={menuId ? queuedProductImageUpdates : undefined}
          updateQueuedProductImageUpdates={menuId ? updateQueuedProductImageUpdates : undefined}
        />
      </FocusTrap>
    );
  return <DetailsV1 currentVenue={currentVenue} dietaryEnums={dietaryEnums} />;
};

export default SingleItem;
